import ApiDescriptionTabs from './ApiDescriptionTabs';

export default ApiDescriptionTabs;
